<template>
  <div class="enrollment-widget">
    <h2><span class="fa fa-bullhorn" /> Enrollment</h2>
    <div v-if="config.endpoint">
      <div v-if="loading">
        Loading Enrollment Data <span class="fa fa-sync anim-spin" />
      </div>
      <template v-else>
        <div>
          <b-tabs>
            <b-tab v-for="(group, index) in stepGroups" :key="index">
              <template #title>
                {{ index | blindName }}
                <b-badge v-if="index > 0">
                  {{ group.count }}
                </b-badge>
              </template>
              <h4 class="pt-3">
                {{ group.name }}
              </h4>
              <table v-if="group.steps.length > 0" class="table table-sm table-striped table-hover">
                <thead>
                  <tr>
                    <th>Step Name</th>
                    <th>Completed Today</th>
                    <th>Total Completed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="step in group.steps">
                    <td>{{ step.name }}</td>
                    <td><a :href="step.completed.linkToAdmin">{{ step.completed.count }}</a></td>
                    <td><a :href="step.total.linkToAdmin">{{ step.total.count }}</a></td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-info">
                This arm has no enrollment steps
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </template>
    </div>
    <div v-else class="center">
      <p>Enrollment Information will display after a page refresh</p>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { BTabs, BTab, BBadge } from 'bootstrap-vue';

  export default {
    components: {
      BTabs,
      BTab,
      BBadge,
    },
    filters: {
      blindName(index) {
        if (index === 0) {
          return 'Study';
        } else {
          return 'Arm ' + index;
        }
      }
    },
    props: {
      config: {
        type: Object,
        default: () => {
          return {endpoint: null};
        }
      }
    },
    data: function () {
      return {
        loading: true,
        stepGroups: []
      };
    },
    mounted: function () {
      if (this.config.endpoint) {
        axios
          .get(
            this.config.endpoint,
            {
              headers: {'X-Requested-With': 'XMLHttpRequest'},
            }
          )
          .then(res => {
            this.loading = false;
            this.stepGroups = res.data;
          });
      }
    },
  };
</script>
<style scoped>
  .center p {
    font-weight: bold;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
